(() => {
  document.documentElement.classList.add('js-enabled');

  /*
   * iOS Safari changes the layout viewport when the address bar expands or
   * collapses. A CSS custom property based on visualViewport keeps the four
   * full-height JSF blocks stable without breaking Android's native svh.
   */
  const setMobileViewportHeight = () => {
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    document.documentElement.style.setProperty('--jsf-mobile-vh', `${viewportHeight * 0.01}px`);
  };

  let viewportFrame = 0;
  const requestViewportUpdate = () => {
    window.cancelAnimationFrame(viewportFrame);
    viewportFrame = window.requestAnimationFrame(setMobileViewportHeight);
  };

  setMobileViewportHeight();
  window.addEventListener('resize', requestViewportUpdate, { passive: true });
  window.addEventListener('orientationchange', requestViewportUpdate, { passive: true });
  window.visualViewport?.addEventListener('resize', requestViewportUpdate, { passive: true });

  const items = document.querySelectorAll('.jsf-reveal');
  if (!items.length) return;

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  items.forEach((item) => observer.observe(item));
})();
